import { render, staticRenderFns } from "./AppIcon.vue?vue&type=template&id=b058bd0c&scoped=true&"
import script from "./AppIcon.vue?vue&type=script&lang=ts&"
export * from "./AppIcon.vue?vue&type=script&lang=ts&"
import style0 from "./AppIcon.vue?vue&type=style&index=0&id=b058bd0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b058bd0c",
  null
  
)

export default component.exports